export default () => {
  return {
    slides: document.querySelectorAll('.product__media-item'),
    controllers: document.querySelectorAll('.slider-counter__link'),
    slideTo (id) {
      if (id != null) {
        let elem = document.getElementById(id)
        elem?.scrollIntoView(
          { behavior: 'smooth', block: 'end', inline: 'nearest' })
      }
    },
    isInViewport () {
      this.slides?.forEach(slide => {
        const rect = slide?.getBoundingClientRect()
        let dot = document?.querySelector(
          `.slideshow__control-wrapper button[aria-controls='${slide.id}']`)

        if (
          rect?.top >= 0 &&
          rect?.left >= 0 &&
          rect?.bottom <=
          (window?.innerHeight || document?.documentElement?.clientHeight) &&
          rect?.right <=
          (window?.innerWidth || document?.documentElement?.clientWidth)
        ) {
          dot?.classList?.remove('opacity-30')
          dot?.classList?.add('opacity-100')
        }
        else {
          dot?.classList?.add('opacity-30')
          dot?.classList?.remove('opacity-100')
        }
      })
    },
    mobile: window.innerWidth < 640,
    isMobile() {
      this.mobile = window.innerWidth < 640
    }
  }
}
